import React from "react";
import { Col } from "reactstrap";
import { isMobile } from "react-device-detect";
import ThumbnailBarButton from "./ThumbnailBarButton";
import ThumbnailGridButton from "./ThumbnailGridButton";

interface IParams {
  isFullscreen: boolean;
  thumbnailBarButtonClick: React.MouseEventHandler<HTMLButtonElement>;
  thumbnailGridButtonClick: React.MouseEventHandler<HTMLButtonElement>;
}

const BottomLeftButtonsContainer: React.FC<IParams> = ({
  isFullscreen,
  thumbnailBarButtonClick,
  thumbnailGridButtonClick,
}) => {
  return (
    <>
      <div className="thumbnails-button">
        <Col xs="2" className="ml-2"></Col>
        <ThumbnailBarButton
          isFullscreen={false}
          onClick={thumbnailBarButtonClick}
          className={`${!isMobile ? "btn-sm" : ""}`}
        />
        {!isFullscreen && (
          <ThumbnailGridButton
            onClick={thumbnailGridButtonClick}
            className={isMobile ? "btn-sm" : ""}
          />
        )}
      </div>
    </>
  );
};

export default BottomLeftButtonsContainer;
